import { Box, Button, Typography, Modal } from "@mui/material";
import { style, header, iconWrapper } from "./modalStyles";
import { Close } from "@mui/icons-material";
import offlineIcon from "../Assets/offline.svg";

const NoNetworkModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box sx={header}>
          <Close onClick={onClose} />
        </Box>
        <Box>
          <Box sx={iconWrapper}>
            <img src={offlineIcon} alt="Offline" />
          </Box>
          <Typography variant="h6" mb={1} align="center">
            Internet is unavailable
          </Typography>
          <Typography variant="body1" mb={2} align="center">
            Your mobile device does not have an active internet connection.
          </Typography>
          <Button onClick={onClose} variant="outlined" size="large" fullWidth mb={1}>
            Check Wi-Fi settings
          </Button>
          <Button onClick={onClose} variant="outlined" size="large" fullWidth>
            Dismiss
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NoNetworkModal;
